import React, { useEffect, useState } from 'react';
import cx from 'classnames';

import Button from 'app/components/ui/Button';

import s from './Bookmark.module.sass';

type BookmarkSvgProps = {
  disabaled?: boolean
  className?: string
  id?: string
  field?: string
};

const BookmarkSvg: React.FC<BookmarkSvgProps> = ({
  disabaled = false,
  className,
  id,
  field,
}) => {
  const [isActive, setActiveState] = useState<boolean>(false);

  const handleSwitchBookmark = () => {
    setActiveState(!isActive);

    if (field && id) {
      const arrayFromLocalStorage: string[] = JSON.parse(localStorage.getItem(field) as string);

      if (arrayFromLocalStorage && arrayFromLocalStorage.length) {
        const findCurrentItem = field === 'tokens' ? arrayFromLocalStorage.find(
          (item: (string | { id: string, tokenId: string, standard: string })) => (
            typeof item === 'string'
              ? item === id
              : id === `${item.id}[${item.standard === 'FA12' ? '0' : item.tokenId}]`
          ),
        ) : arrayFromLocalStorage.find(
          (item: (string | { id: string })) => (
            typeof item === 'string'
              ? item === id
              : item.id === id
          ),
        );

        if (findCurrentItem && isActive) {
          const removeCurrentItem = field === 'tokens' ? arrayFromLocalStorage.filter(
            (item: (string | { id: string, tokenId: string, standard: string })) => (
              typeof item === 'string'
                ? item !== id
                : id !== `${item.id}[${item.standard === 'FA12' ? '0' : item.tokenId}]`
            ),
          ) : arrayFromLocalStorage.filter(
            (item: (string | { id: string })) => (
              typeof item === 'string'
                ? item !== id
                : item.id !== id
            ),
          );
          localStorage.setItem(field, JSON.stringify(removeCurrentItem));
        }

        if (!findCurrentItem) {
          arrayFromLocalStorage.push(id);
          localStorage.setItem(field, JSON.stringify(arrayFromLocalStorage));
        }
      } else {
        localStorage.setItem(field, JSON.stringify([id]));
      }
    }
  };

  useEffect(() => {
    if (field) {
      const arrayFromLocalStorage: any[] = JSON.parse(localStorage.getItem(field) as string);

      if (arrayFromLocalStorage && arrayFromLocalStorage.length) {
        if (id) {
          const findCurrentItem = field === 'tokens' ? arrayFromLocalStorage.find(
            (item: (string | { id: string, tokenId: string, standard: string })) => (
              typeof item === 'string'
                ? item === id
                : id === `${item.id}[${item.standard === 'FA12' ? '0' : item.tokenId}]`
            ),
          ) : arrayFromLocalStorage.find(
            (item: (string | { id: string })) => (
              typeof item === 'string'
                ? item === id
                : item.id === id
            ),
          );

          if (findCurrentItem) {
            setActiveState(true);
          }
        }
      }
    }
  }, [field, id]);

  const compoundClassName = cx(
    s.bookmark,
    { [s.active]: isActive },
    { [s.disabled]: disabaled },
  );

  return (
    <Button
      theme="clear"
      className={cx(s.container, className)}
      onClick={handleSwitchBookmark}
    >
      <svg className={compoundClassName} width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path className={cx(s.background)} d="M0 0H16V16L8 8L0 16V0Z" />
        <path
          className={cx(s.stroke)}
          d="M7.64645 7.64645L0.5 14.7929V0.5H15.5V14.7929L8.35355 7.64645L8 7.29289L7.64645 7.64645Z"
        />
      </svg>
    </Button>
  );
};
export default BookmarkSvg;
